import {
  Activity as TActivity,
  Activity,
  ActivityFragmentFragment,
  ActivityTeaserFragmentFragment,
  Hotel,
  HotelTeaserFragmentFragment,
  ParagraphActivityTabData,
  Poi,
  PoiTeaserFragmentFragment,
} from '../generated/types';
import { Maybe } from 'graphql/jsutils/Maybe';
import { useMemo } from 'react';
import { useStore } from '../store/provider';

export default function useActivityHotelMarkers(
  data: ActivityFragmentFragment,
  categoryKey: string | null = null
) {
  const store = useStore();

  return useMemo(() => {
    let markers: any[] = [];
    if (
      data.hotels &&
      data.hotels.items &&
      store.config.renderConfig.activity.hotelActivities
    ) {
      markers = markers.concat(
        data.hotels.items.reduce<
          Array<
            | TActivity
            | ActivityTeaserFragmentFragment
            | PoiTeaserFragmentFragment
            | Hotel
            | HotelTeaserFragmentFragment
            | Poi
          >
        >((val, curr) => {
          // Add hotel activities
          if (store.config.renderConfig.activity.hotelActivities) {
            if (!categoryKey) {
              val = val.concat(curr!.activities!);
            } else {
              val = val.concat(
                curr!.activities!.filter(
                  (activity) => activity.category.key === categoryKey
                )
              );
            }
          }

          // Add the hotel
          val = val.concat(curr!);

          return val;
        }, [])
      );
    }

    if (
      data.nearActivities &&
      store.config.renderConfig.activity.nearActivities
    ) {
      markers = markers.concat(data.nearActivities.items);
    }

    if (data.nearPois && store.config.renderConfig.activity.nearPois) {
      markers = markers.concat(data.nearPois.items);
    }

    if (data.nearHotels && store.config.renderConfig.activity.nearHotels) {
      markers = markers.concat(data.nearHotels.items);
    }

    return markers;
  }, [data]);
}
